import React from "react";
import * as footerConfig from "./footer.config";
//
import "../footer/footer.component.scss";
import { Link } from "react-router-dom";

interface Props {}

const Footer: React.FC<Props> = () => {
  return (
    <div className="footer">
      <div className="footer__wrapper">
        <div className="footer-left">
          <ul className="footer-list">
            {footerConfig.footer.right.map((item, key) => (
              <li className="footer-list__item" key={key}>
                {item.link.startsWith("https") ? (
                  <a href={item.link} target="_blank" rel="norefferer">
                    {item.label}
                  </a>
                ) : (
                  <Link to={item.link}>{item.label}</Link>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div className="footer-right">
          <span>{footerConfig.footer.left.label}</span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
